<div class="spinner-container is-flex is-justify-content-center">
    <fa-duotone-icon class="spinner-icon" [icon]="faSpinner" animation="spin" [swapOpacity]="true"></fa-duotone-icon>
</div>
  